import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function IngredientsSection() {
  return <section id="ingredients" className="py-16 bg-gray-100" data-id="element-237">
      <div className="container mx-auto px-4" data-id="element-238">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-6 font-serif" data-id="element-239">
          THE WARRIOR'S SECRET
        </h2>
        <div className="w-24 h-1 bg-blue-600 mx-auto mb-12" data-id="element-240"></div>
        <div className="max-w-4xl mx-auto mb-16 flex flex-col md:flex-row items-center gap-8" data-id="element-241">
          <div className="md:w-1/2" data-id="element-242">
            <p className="mb-6 text-lg" data-id="element-243">
              In the mountains of Malaysia, there's a tree the locals call
              "Pokok Ubat" – the medicine tree.
            </p>
            <p className="mb-6" data-id="element-244">
              For over 1,000 years, Malay warriors have used its root to
              maintain their strength and virility well into old age.
            </p>
            <p className="mb-6" data-id="element-245">
              They called it "Tongkat Ali" – Ali's walking stick – after a
              legendary warrior whose prowess in battle and in the bedroom
              became the stuff of legend.
            </p>
            <p className="mb-6" data-id="element-246">But it wasn't just folklore.</p>
            <p className="mb-6" data-id="element-247">
              Modern science has proven that this ancient root contains
              compounds that work like molecular switches, turning your
              testosterone production back ON.
            </p>
          </div>
          <div className="md:w-1/2" data-id="element-248">
            <img src="https://images.unsplash.com/photo-1591911823001-f1c5a8609a8e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80" alt="Natural herbal ingredients" className="rounded-lg shadow-xl w-full h-auto" data-id="element-249" />
          </div>
        </div>
        <div className="mb-16" data-id="element-250">
          <h3 className="text-2xl font-bold text-center mb-10" data-id="element-251">
            INTRODUCING 247ALPHA: NATURE'S ANSWER TO PHARMACEUTICAL GREED
          </h3>
          <div className="max-w-4xl mx-auto" data-id="element-252">
            <p className="mb-8 text-lg" data-id="element-253">
              After three years of research and development, we've finally
              cracked the code.
            </p>
            <p className="mb-8" data-id="element-254">
              247Alpha isn't just another testosterone booster filled with cheap
              herbs and false promises.
            </p>
            <p className="mb-8" data-id="element-255">
              It's a precisely formulated blend of the world's most powerful
              natural testosterone optimizers, combined in the exact ratios used
              by traditional healers for over 1,000 years.
            </p>
            <div className="bg-gray-800 p-5 rounded-lg shadow-lg flex flex-col md:flex-row items-center gap-4 mt-10" data-id="element-256">
              <div className="md:w-1/4" data-id="element-257">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/i7n1HjkJV7hZe3cdfgoPvA/1000001242.png" alt="247Alpha Supplement Bottle" className="w-32 h-auto mx-auto" data-id="element-258" />
              </div>
              <div className="md:w-3/4 text-center md:text-left" data-id="element-259">
                <p className="text-blue-400 font-bold mb-2" data-id="element-260">
                  FOR A LIMITED TIME SAVE 50%
                </p>
                <a href="https://the247alpha.com/products/alpha-energy?variant=52325407719751" className="inline-block bg-blue-800 hover:bg-blue-900 text-white px-8 py-3 rounded-md font-bold transition duration-300 w-full md:w-auto text-center" data-id="element-261">
                  Try 247Alpha Risk-Free
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="max-w-5xl mx-auto" data-id="element-262">
          <h3 className="text-2xl font-bold mb-8" data-id="element-263">The 247Alpha Formula</h3>
          <div className="grid md:grid-cols-2 gap-8" data-id="element-264">
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-265">
              <div className="flex items-start" data-id="element-266">
                <CheckCircleIcon className="text-blue-600 mr-3 mt-1 flex-shrink-0" size={24} data-id="element-267" />
                <div data-id="element-268">
                  <h4 className="font-bold mb-2" data-id="element-269">
                    Tongkat Ali Extract (400mg)
                  </h4>
                  <p data-id="element-270">
                    The "Malaysian Viagra" standardized to 100:1 concentration –
                    the same potency used in clinical trials showing 37%
                    testosterone increases.
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-271">
              <div className="flex items-start" data-id="element-272">
                <CheckCircleIcon className="text-blue-600 mr-3 mt-1 flex-shrink-0" size={24} data-id="element-273" />
                <div data-id="element-274">
                  <h4 className="font-bold mb-2" data-id="element-275">
                    Tribulus Terrestris (500mg)
                  </h4>
                  <p data-id="element-276">
                    Sourced from Bulgaria where it grows wild in mineral-rich
                    soil. Standardized to 45% saponins for maximum potency.
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-277">
              <div className="flex items-start" data-id="element-278">
                <CheckCircleIcon className="text-blue-600 mr-3 mt-1 flex-shrink-0" size={24} data-id="element-279" />
                <div data-id="element-280">
                  <h4 className="font-bold mb-2" data-id="element-281">Horny Goat Weed (300mg)</h4>
                  <p data-id="element-282">
                    Extracted to 20% icariin content – the active compound that
                    supports healthy blood flow and sexual function.
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-283">
              <div className="flex items-start" data-id="element-284">
                <CheckCircleIcon className="text-blue-600 mr-3 mt-1 flex-shrink-0" size={24} data-id="element-285" />
                <div data-id="element-286">
                  <h4 className="font-bold mb-2" data-id="element-287">Saw Palmetto (250mg)</h4>
                  <p data-id="element-288">
                    Wild-harvested from Florida and concentrated to 45% fatty
                    acids for optimal DHT blocking.
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-289">
              <div className="flex items-start" data-id="element-290">
                <CheckCircleIcon className="text-blue-600 mr-3 mt-1 flex-shrink-0" size={24} data-id="element-291" />
                <div data-id="element-292">
                  <h4 className="font-bold mb-2" data-id="element-293">
                    Magnesium Glycinate (200mg)
                  </h4>
                  <p data-id="element-294">
                    The most bioavailable form of magnesium, essential for
                    testosterone synthesis and muscle recovery.
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-295">
              <div className="flex items-start" data-id="element-296">
                <CheckCircleIcon className="text-blue-600 mr-3 mt-1 flex-shrink-0" size={24} data-id="element-297" />
                <div data-id="element-298">
                  <h4 className="font-bold mb-2" data-id="element-299">Zinc Picolinate (15mg)</h4>
                  <p data-id="element-300">
                    Superior absorption compared to cheap zinc oxide. Critical
                    for testosterone production and immune function.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-gray-800 p-5 rounded-lg shadow-lg flex flex-col md:flex-row items-center gap-4 mt-12" data-id="element-301">
            <div className="md:w-1/4" data-id="element-302">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/i7n1HjkJV7hZe3cdfgoPvA/1000001242.png" alt="247Alpha Supplement Bottle" className="w-32 h-auto mx-auto" data-id="element-303" />
            </div>
            <div className="md:w-3/4 text-center md:text-left" data-id="element-304">
              <p className="text-blue-400 font-bold mb-2" data-id="element-305">
                LIMITED TIME OFFER - 50% OFF TODAY
              </p>
              <a href="https://the247alpha.com/products/alpha-energy?variant=52325407719751" className="inline-block bg-blue-800 hover:bg-blue-900 text-white px-8 py-3 rounded-md font-bold transition duration-300 w-full md:w-auto text-center" data-id="element-306">
                Get Your 30-Day Supply
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}